import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import PackagesList from "@/pages/PackagesList";
import PackageDetail from "@/pages/PackageDetail";
import Contact from "@/pages/Contact";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import SiteLayout from "@/components/SiteLayout";
import ScrollToTop from "@/components/ScrollToTop";

function App() {
  return (
    <div className="App font-body" data-testid="app-root">
      <Toaster position="top-center" richColors />
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route element={<SiteLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/packages" element={<PackagesList />} />
            <Route path="/packages/:slug" element={<PackageDetail />} />
            <Route path="/contact" element={<Contact />} />
          </Route>
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
